import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      height: 'auto',
      position: 'relative'
    },
    wrapperContent: {
      [theme.breakpoints.up(1320)]: {
      maxWidth:'860px',
      },
      width: '100%',
    },
    title: {
      color: '#0047BA',
      fontSize: '22px',
      fontWeight: 'bold',
    },
    contentContainer: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #FCFCFC',
      borderRadius: '13px',
      boxShadow: '0px 5px 20px #64646433'
    },
    img: {
      width: '100%',
      height: '300px',
      borderRadius: '13px',
      objectFit: 'fill',
      '& + img': {
        marginLeft: '10px'
      }
    },
    containerDetails: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      top: 260,
      right: 180,
      maxWidth: '720px',
      width: '100%',
      height: '400px',
      padding: theme.spacing(2,3),
      backgroundColor: '#FFFFFF',
      border: '1px solid #fcfcfc',
      borderRadius: '13px',
      boxShadow: '0px 5px 20px #64646433'
    },
    contentDetails: {
      display: 'flex',
      flexDirection: 'column',
      width: "420px",
    },
    header: {
      display: 'flex',
      width: '100%',
      marginBottom: '16px',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    main: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '300px',
      marginBottom: '14px',
      width: '100%',
    },
    brandCar: {
      color: '#646464',
      fontSize: '22px',
      textTransform: 'uppercase',
      marginRight: '4px'
    },
    nameCar: {
      color: theme.palette.primary.main,
      fontSize: '22px',
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    fipePrice: {
      color: '#C4C4C4',
      fontSize: '14px',
      textAlign: 'right',
      fontWeight: 'bold'
    },
    comonTitle: {
      color: '#C4C4C4',
      fontWeight: 'bold',
      fontSize: '11px',
    },
    accessories: {
      width: '200px',
    },
    button: {
      height: '33px',
      color: '#ffffff',
      backgroundColor: '#0047BA',
      border: '1px solid #0047BA',
      borderRadius: '17px',
      marginBottom: '20px'
    },
    strong: {
      display: 'block',
      '& + strong': {
        marginTop: '10px'
      }
    },
    termsWrapper: {
      display: 'flex',
      alignItems: 'baseline',
      margin: '30px auto',
      [theme.breakpoints.down(480)]: {
        width: '340px',
        padding: '0 16px',
        margin: '80px auto',
        textAlign: 'justify'
      },
    },
    termsText: {
      color: '#00B5EE',
      fontSize: '16px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px'
      },
    },
    buttonTerms: {
      alignSelf: 'center',
      width: '166px',
      height: '33px',
      borderRadius: '17px',
      margin: '16px 8px',
      backgroundColor: '#0047BA',
      color: '#FFF',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      [theme.breakpoints.down(480)]: {
        margin: '0 auto',
      },
    },
    buttonTermsDisabled: {
      alignSelf: 'center',
      width: '166px',
      height: '33px',
      borderRadius: '17px',
      margin: '16px 8px',
      backgroundColor: '#D4D4D4',
      color: '#FFF',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      [theme.breakpoints.down(480)]: {
        margin: '0 4px'
      },
    },
    check: {
      marginRight: '6px',
    },
    warning: {
      width: '204px',
      padding: '10px 10px',
      backgroundColor: '#FCFCFC',
      border: '1px solid #F0F0F0',
      borderRadius: '13px',
      position: 'absolute',
      right: '10px',
      [theme.breakpoints.down(1320)]: {
        width: '340px',
        top: '320px',
        position: 'unset',
        margin: '16px auto'
      },
    },
    warningTitle: {
      color: '#0047BA',
      fontWeight: 'bold',
      fontSize: '15px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px'
      },
    },
    warningText: {
      color: '#646464',
      fontSize: '14px',
      letterSpacing: '0px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px'
      },
    },
    buttonsSubmit: {
      '& + button': {
        marginLeft: '6px'
      },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      margin: '16px auto',
    },
  })
)

export default useStyles;